// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/landing-clearance-and-go-around.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/landing-clearance-and-go-around/landing-clearance-and-go-around.js';

mount([g0]);
